import {useEffect} from 'react';
import {useSelector, useStore} from 'react-redux';
import {isFabricWebview} from '~/common/utils/webview';
import {checkForNewMessages} from '~/ViewInvitation/reducers/apiActions';
import {bgLightness} from '~/ViewInvitation/utils/color';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {InvitationLink} from './InvitationLink';

export const ViewInvitationTabs = (props) => {
  const {active, bgAlpha = 1, ctaWordings, themeColor = 'white'} = props;
  const store = useStore();
  const {matches: lgWindow} = useMatchQuery('(min-width: 80rem)', []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    // TODO: should we run this on route change like we do on view_invitation classic?
    store.dispatch(checkForNewMessages());
    const ptr = setInterval(() => store.dispatch(checkForNewMessages()), 30000);
    return () => clearInterval(ptr);
  }, [checkForNewMessages]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (!isFabricWebview()) {
      if (!lgWindow) {
        window.scrollTo(0, 116);
      } else {
        window.scrollTo(0, 126);
      }
    }
  }, []);

  const showNotification = useSelector((s) => s.newMessages?.hasNewMessages);

  return (
    <div className="view-invitation__tabs">
      <InvitationLink to="/">
        <button
          id="tab-button_invitation"
          type="button"
          data-qa-id="invitation-tab"
          className={`unstyled-button tab-button ${
            bgLightness(themeColor, bgAlpha) === 'dark' ? 'on-dark-bg' : ''
          } ${active !== 'messages' ? 'active' : ''}`}
        >
          {ctaWordings || 'Invitation'}
        </button>
      </InvitationLink>
      <InvitationLink to="/messages">
        <button
          id="tab-button_messages"
          type="button"
          data-qa-id="messages-tab"
          className={`unstyled-button tab-button tab-messages ${
            bgLightness(themeColor, bgAlpha) === 'dark' ? 'on-dark-bg' : ''
          } ${active === 'messages' ? 'active' : ''}`}
        >
          <div className="tab-messages">
            <span className="tab-messages-text">
              Messages
              {showNotification && <i className="new-message" />}
            </span>
          </div>
        </button>
      </InvitationLink>
    </div>
  );
};
